import { SearchOutlined } from "@ant-design/icons";
import { Card, Skeleton, Typography } from "antd";
import { useState } from "react";

import "./index.scss";

const { Title } = Typography;

interface Props {
  title: string;
  docCount: number;
  docType: string;
  icon: any;
  loading: boolean;
  onClick(onClick: any): any;
}

const DocumentCard: React.FC<Props> = ({ title, docCount, docType, icon, loading, onClick}) => {
  const [loadingCover, setLoadingCover] = useState(true);

  return (
    <Card onClick={onClick} //TODO putting onClick here so the whole card is clickable. Disable this click while fetching the unread count or move this onClick to actions
      className="mt-2 ml-2 mr-2 card-container"
      hoverable
      loading={loading}
      title={
        <div>
          {icon}&nbsp;&nbsp;{title}
        </div>
      }
      actions={[
        <div>
          <SearchOutlined /> View
        </div>,
      ]}
    >
      <Skeleton loading={loading} active paragraph={{ rows: 8 }}>
        <div className="card-content">
          <Title level={2}>{docCount}</Title>
        </div>
        <div className="card-content">
          <p>Unread {docType}</p>
        </div>
      </Skeleton>
    </Card>
  );
};

export default DocumentCard;
